import App from './App.svelte';

const app = new App({
	target:  document.querySelector('#straalendescroll')
});

export default app;